import React from "react";
import "./styles.css";

const OrbitIcon = ({ isActive, handleClick }) => {
  return (
    <div className="icon-container">
      <a className="icon-anchor" onClick={handleClick}>
        <svg
          className="svg-container element-icon"
          width="100%"
          height="100%"
          viewBox="0 0 512 512"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xmlSpace="preserve"
          xmlnsserif="http://www.serif.com/"
        >
          <g transform="matrix(1.79021,0,0,1.79021,53.7063,19.6923)">
            <circle className={`el-circle ${isActive ? "active" : ""}`} cx="113" cy="132" r="143" />
          </g>
          <g id="Shape" transform="matrix(14.3576,0,0,14.3576,85.1424,83.7085)">
            <path
              className="el-path"
              d="M7.57,4.482C8.528,2.566 10.037,1 12,1C13.389,1 14.559,1.798 15.439,2.904C16.228,3.895 16.854,5.212 17.288,6.711C17.801,6.86 18.29,7.03 18.749,7.22C20.578,7.976 22.115,9.118 22.727,10.624C22.934,11.135 22.688,11.719 22.176,11.927C21.665,12.134 21.081,11.888 20.874,11.376C20.558,10.6 19.614,9.742 17.985,9.068C16.394,8.411 14.309,8 12,8C10.698,8 9.47,8.131 8.361,8.361C8.131,9.47 8,10.698 8,12C8,13.302 8.131,14.53 8.361,15.639C9.47,15.869 10.698,16 12,16C13.636,16 15.157,15.794 16.469,15.441L14.756,14.606C14.259,14.364 14.053,13.765 14.295,13.269C14.537,12.772 15.136,12.566 15.632,12.808L19.446,14.668C19.943,14.91 20.149,15.509 19.907,16.005L18.047,19.819C17.805,20.316 17.206,20.522 16.71,20.28C16.213,20.038 16.007,19.439 16.249,18.943L17.019,17.364C15.508,17.774 13.798,18 12,18C10.959,18 9.947,17.924 8.987,17.781C9.103,18.079 9.227,18.36 9.359,18.624C10.211,20.327 11.202,21 12,21C12.205,21 12.413,20.959 12.624,20.873C13.136,20.666 13.719,20.912 13.927,21.424C14.134,21.936 13.888,22.519 13.376,22.727C12.941,22.903 12.479,23 12,23C10.037,23 8.528,21.434 7.57,19.518C7.235,18.848 6.946,18.099 6.711,17.289C5.901,17.054 5.152,16.765 4.482,16.43C2.566,15.472 1,13.963 1,12C1,10.037 2.566,8.528 4.482,7.57C5.152,7.235 5.901,6.946 6.711,6.711C6.946,5.901 7.235,5.152 7.57,4.482ZM8.987,6.219C9.947,6.076 10.959,6 12,6C13.042,6 14.053,6.076 15.014,6.219C14.686,5.378 14.296,4.679 13.874,4.149C13.214,3.32 12.563,3 12,3C11.202,3 10.211,3.673 9.359,5.376C9.227,5.64 9.103,5.921 8.987,6.219ZM6.219,8.987C5.921,9.103 5.64,9.227 5.376,9.359C3.673,10.211 3,11.202 3,12C3,12.798 3.673,13.789 5.376,14.641C5.64,14.773 5.921,14.897 6.219,15.014C6.076,14.053 6,13.041 6,12C6,10.959 6.076,9.947 6.219,8.987Z"
            />
          </g>
        </svg>
        <div className="tooltip-btm">
          <p>Orbit controls (2D graphics)</p>
          <div className="triangle-btm"></div>
        </div>
      </a>
    </div>
  );
};
export default OrbitIcon;
